import { Controller } from "@hotwired/stimulus"

// Polls for the satellite cover image after project creation.
// Waits until StoreAssetJob uploads the file to S3, then fades it in.
export default class extends Controller {
  static targets = ["image"]
  static values = {
    projectId: Number,
    pollInterval: { type: Number, default: 3000 },
    maxAttempts: { type: Number, default: 15 } // ~45s covers geocode + satellite fetch + S3 upload
  }

  connect() {
    this._attempts = 0
    this._poll()
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  _poll() {
    this._attempts++
    if (this._attempts > this.maxAttemptsValue) return

    fetch(`/projects/${this.projectIdValue}/cover_image_status.json`, {
      headers: { Accept: "application/json" }
    })
      .then(r => r.json())
      .then(data => {
        if (data.ready) {
          this._swapImage(data.url)
        } else {
          this._timer = setTimeout(() => this._poll(), this.pollIntervalValue)
        }
      })
      .catch(() => {
        this._timer = setTimeout(() => this._poll(), this.pollIntervalValue)
      })
  }

  _swapImage(url) {
    const img = this.imageTarget
    img.classList.add("opacity-0")
    img.onload = () => img.classList.remove("opacity-0")
    img.onerror = () => {
      // File might not be fully propagated yet — retry once after a short delay
      setTimeout(() => {
        img.onload = () => img.classList.remove("opacity-0")
        img.onerror = null
        img.src = url
      }, 2000)
    }
    img.src = url
  }
}
